import { render, staticRenderFns } from "./MV.vue?vue&type=template&id=0a4ff05c"
import script from "./MV.vue?vue&type=script&lang=js"
export * from "./MV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports